import React from 'react';
import { useSelector } from 'react-redux';
import './BasemapSelectorToggle.scss';

export const BasemapSelector = () => {
  const showBasemapSelector = useSelector(
    store => store.mapview.showBasemapSelector
  );
  return (
    <div
      className={`basemap-container ${showBasemapSelector ? '' : 'hidden'}`}
      id="basemap-div"
    />
  );
};
